import React, { useEffect } from "react";
import { observer } from "mobx-react";
import CheerList from "../../Cheer/CheerList";
import BottomBar from "../../BottomBar/BottomBar";
import Scrollbar from "../../ui/Scrollbar";
import useCheersStore from "../../../../../common/hooks/useCheersStore";
import style from "./CheerListTab.module.scss";
import Loader from "../../../../../common/components/Loader";
import { REFRESH_INTERVAL } from "../../../../../common/constants/refreshInterval";

const CheerListTab: React.FC = observer(() => {
  const cheersStore = useCheersStore();
  const { cheers, error } = cheersStore.cheersList;

  useEffect(() => {
    cheersStore.getCheers();

    const interval = setInterval(() => {
      cheersStore.getCheers();
    }, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [cheersStore]);

  if (error) return <div className={style.cheerListTab__warningInfo}>{error.message}</div>;

  if (!cheers)
    return (
      <div className={style.cheerListTab__warningInfo}>
        <Loader />
      </div>
    );

  if (cheers.length === 0) return <div className={style.cheerListTab__warningInfo}>No cheers yet!</div>;

  return (
    <div className={style.cheerListTab}>
      <div className={style.cheerListTab__content}>
        <Scrollbar>
          <CheerList
            data={cheers.map((cheer) => {
              return {
                img: cheer.emote.imageUrl,
                title: cheer.user.username,
                subtitle: cheer.createdAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
                amount: cheer.bitsAmount,
              };
            })}
          />
        </Scrollbar>
      </div>
      <div className={style.cheer__bottomBar}>
        <BottomBar />
      </div>
    </div>
  );
});

export default CheerListTab;
